import React, { useEffect, useState } from "react";
import {
  dashboardConstants,
  sportConstants,
  translationConstants,
  refreshDispatch,
  Directions,
} from "../../../../constants";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import {
  EventActions,
  SpotActions,
  UserActions,
  authActions,
  competitionActions,
} from "../../../../redux/actions";
import InfiniteScroll from "react-infinite-scroll-component";
import { getUserPayload } from "../../../../system";
import MyCompetitionCard from "./MyCompetitionCard/MyCompetitionCard";
import StatCard from "../Dashboard/Components/StatCard";
import nationalRanking from "../../../../assets/images/dashboard/ranking.png";
import nationalScore from "../../../../assets/images/dashboard/score.png";
import noOfCompetitions from "../../../../assets/images/dashboard/no_of_competitions.svg";
import { allSharedComponents } from "../../../../shared";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../shared/utilitiies";
import TimezoneDisplayText from "../../../../shared/components/TimezoneDisplayText/TimezoneDisplayText";

const defaultQueryExpression = "id != null";

//-------initial gridstate
const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "startDate desc",
  filterQuery: defaultQueryExpression,
};

const MyCompetitions = () => {
  const { DeleteModal, CustomModal } = allSharedComponents;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [competitionData, setCompetitionData] = useState();
  const [gridState, setGridState] = useState(initialGridState);
  const [myCompetitionsPageData, setMyCompetitionPageData] = useState([]);
  const userPayload = getUserPayload();
  const spots = useSelector((state) => state.SpotsReducer.publicSpots);
  const [spotFilter, setSpotFilter] = useState("");

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData?.user?.id
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const myCompetitions = useSelector(
    (state) => state.CompetitionReducer.myCompetitionsData?.pageData
  );
  const competitionStats = useSelector(
    (state) => state.CompetitionReducer?.competitionStats
  );
  const isViewModal = useSelector((state) => {
    return state.CompetitionReducer.isViewModal;
  });
  const cities = useSelector((state) => state.LoginReducer.cities);

  // const { nationalStats } = competitionStats;
  useEffect(() => {
    const body = {
      length: null,
    };
    dispatch(SpotActions.GetAllPublicSpots(body));
    dispatch(UserActions.getUserSportsById(systemUserId));
  }, [dispatch]);

  const userSports = useSelector((state) => state.UserReducer?.userSports);

  useEffect(() => {
    dispatch(
      competitionActions.getMyCompetitions(gridState, userPayload?.user?.id)
    );
    dispatch(competitionActions.getCompetitionStats(userPayload?.user?.id));
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, [gridState]);

  useEffect(() => {
    setMyCompetitionPageData(myCompetitions);
  }, [myCompetitions]);

  const handleSpotChange = (event) => {
    const updatedGridState = { ...gridState };
    const sportId = event.target.value;
    setSpotFilter(sportId);

    if (sportId) {
      updatedGridState.filterQuery = `sportId = ${sportId} && ${defaultQueryExpression}`;
    } else {
      updatedGridState.filterQuery = defaultQueryExpression; // Or reset to default if cityId is empty
    }

    setGridState(updatedGridState);
  };
  const handleClearFilters = () => {
    setSpotFilter("");
    setGridState({
      ...gridState,
      filterQuery: defaultQueryExpression,
    });
  };
  const getMoreEvents = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  const cancellationData = () => {
    if (competitionData?.isPublicRegistrationAllowed) {
      dispatch(
        competitionActions.cancelRegistrationPublic(
          userPayload?.user?.id,
          competitionData?.id,
          null,
          refreshDispatch.MY_COMPETITION
        )
      );
    } else {
      dispatch(
        competitionActions.cancelRegistrationPrivate(
          userPayload?.user?.id,
          competitionData?.id,
          null,
          refreshDispatch.MY_COMPETITION
        )
      );
    }
    dispatch(competitionActions.toggleViewModal(!isViewModal));
  };

  const onDelete = (data) => {
    setTitle(
      data?.isPublicRegistrationAllowed
        ? t(translationConstants.CANCEL_COMPETITION_REGISTRATION)
        : t(translationConstants.CANCEL_INVITE)
    );
    setMessage(
      `${t(translationConstants.ARE_YOU_SURE_WANT_TO_CANCEL)} ${
        direction === Directions.rtl && data?.arabicTitle
          ? `${data?.arabicTitle}`
          : `${data?.title}`
      } ${t(translationConstants.REGISTRATION)}`
    );
    setCompetitionData(data);
    dispatch(competitionActions.toggleViewModal(!isViewModal));
  };

  return (
    <div className="d-md-flex">
      <div className="d-block d-md-none col-12 px-3 ">
        <p className="UserTabHeading">
          {t(translationConstants.MY_COMPETITIONS)}
        </p>
      </div>
      <div className="container pe-md-3 d-flex flex-column-reverse flex-md-row ">
        {/* when ranking component is showning then set the col-md-9 */}
        <div className="col-md-12 col-12">
          <div className="row w-100">
            <div className="d-none d-md-block col-12 col-md-6">
              <p className="UserTabHeading">
                {t(translationConstants.MY_COMPETITIONS)}
              </p>
            </div>
            <div className="col-12 col-md-6 d-md-flex gap-2 justify-content-end align-items-center">
              <div className="row w-100 justify-content-end">
                <div className="col-12 col-md-7 d-flex align-items-center mx-1">
                  <Form.Select
                    className="custom-select-icon filter-style"
                    aria-label="Default select example"
                    onChange={handleSpotChange}
                    value={spotFilter}
                  >
                    <option value="">
                      {t(translationConstants.SELECT_COMPETITION_SPORT_TYPE)}
                    </option>
                    {Object.entries(sportConstants).map(([sport, value]) => (
                      <option key={value} value={value}>
                        {t(translationConstants[sport])}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                {spotFilter && (
                  <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-end align-items-center mx-0 mx-md-3">
                    <div className="cancel-filter" onClick={handleClearFilters}>
                      {t(translationConstants.CLEAR_FILTERS)}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <TimezoneDisplayText />
          <div>
            <InfiniteScroll
              dataLength={
                myCompetitionsPageData?.filter((com) => com.isActive).length ??
                0
              }
              next={getMoreEvents}
              hasMore={
                myCompetitionsPageData?.length % 7 === 0 &&
                myCompetitionsPageData?.length !== 0
                  ? true
                  : false
              }
              loader={loadingIndicator(t)}
              endMessage={dataEndMessage(t, myCompetitionsPageData)}
              style={{ overflow: "hidden" }}
              scrollableTarget={"main-container"}
            >
              <div className="row m-0 w-100">
                {myCompetitionsPageData?.map((competition) => {
                  const city = cities?.find(
                    (s) => s.id === competition?.cityId
                  );
                  return (
                    <MyCompetitionCard
                      city={city}
                      competition={competition}
                      onDelete={onDelete}
                    />
                  );
                })}
              </div>
            </InfiniteScroll>
          </div>
        </div>
        {/* Temporarily Hidding the National Ranking */}
        {/* <div className="d-flex flex-column flex-md-row col-12 col-md-3 mt-3">
          <div className="col-12 d-flex flex-row flex-md-column justify-content-start ">
            <div className="col-4 col-md-12 dashboard-main-content">
              <StatCard
                col={12}
                nationalStats={competitionStats?.nationalStats}
                statType={dashboardConstants.RANKING}
                image={nationalRanking}
                userSports={userSports}
                competitionSportsCount={null}
                isCompetition={true}
              />
            </div>
            <div className="col-4 col-md-12 mt-md-4 dashboard-main-content">
              <StatCard
                col={12}
                nationalStats={competitionStats?.nationalStats}
                statType={dashboardConstants.SCORE}
                image={nationalScore}
                userSports={userSports}
                competitionSportsCount={null}
                isCompetition={true}
              />
            </div>
            <div className="col-4 col-md-12 mt-md-4 dashboard-main-content">
              <StatCard
                col={12}
                nationalStats={competitionStats?.competitionSportsCount}
                statType={dashboardConstants.NOOFCOMPETITION}
                image={noOfCompetitions}
                userSports={userSports}
                competitionSportsCount={
                  competitionStats?.competitionSportsCount
                }
                isCompetition={true}
              />
            </div>
          </div>
        </div> */}
      </div>
      <CustomModal
        scrollable={true}
        size="md"
        setShow={onDelete}
        show={isViewModal}
        customClass="view-user-modal"
      >
        <DeleteModal
          title={title}
          message={message}
          removeRowData={cancellationData}
          onCancel={() => {
            dispatch(competitionActions.toggleViewModal(!isViewModal));
          }}
        />
      </CustomModal>
    </div>
  );
};

export default MyCompetitions;
